import { BaseGenreFieldsFragment } from '@cms/graphql/gamesOverviewPage.generated';

export const parseGenresToCarouselSlides = (genres: BaseGenreFieldsFragment[]) => {
  return genres
    .filter(genre => genre?.__typename === 'ComponentGameGenre')
    .map(({ name, image }) => ({
      title: name,
      image: { alt: image.description || image.title, src: image.url },
    }));
};
